import React, { useState, useEffect } from 'react';
import {
  useSearchParams,
  useNavigate,
  createSearchParams,
} from 'react-router-dom';
import moment from 'moment';

import SurveyAnswerView from './SurveyAnswerView';
import { useQuery } from '../../../hooks/useQuery';
import useStoreSite from '../../../hooks/useStoreSite';
import { GRID_LINK_CELL_STYLE } from '../../../config/contants';

// const sleep = ms => new Promise(r => setTimeout(r, ms));

// 상태
const statusMap = {
  W: '대기',
  P: '진행',
  E: '종료',
};

/**
 * 설문관리 > 설문응답관리
 * @returns
 */
function SurveyAnswer() {
  const navigate = useNavigate();

  /**
   * @todo-사이트ID 확인 필요
   * store state - siteId
   */
  // const storeSiteId = useSelector(state => state.site.siteId, shallowEqual);
  const { siteId: storeSiteId } = useStoreSite();
  const SITE_ID = !storeSiteId
    ? process.env.REACT_APP_DEFAULT_SITE_ID
    : storeSiteId;

  // initial search values
  const initialSearchValues = {
    pageIndex: 1,
    pageSize: 10,
    recordCountPerPage: 10,
    siteId: SITE_ID,
  };

  /** query string */
  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState(initialSearchValues);
  const [paging, setPaging] = useState();

  const [columnDefs] = useState([
    {
      field: '',
      headerName: '',
      width: 50,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      field: 'rnum',
      headerName: 'No',
      width: 60,
    },
    {
      field: 'qustnrSj',
      headerName: '제목',
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        ...GRID_LINK_CELL_STYLE,
        whiteSpace: 'normal',
        // lineHeight: '1.5rem',
      },
      width: 250,
    },
    {
      field: 'qustnrRange',
      headerName: '기간',
      width: 150,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        whiteSpace: 'normal',
        //  lineHeight: '1.5rem'
      },
      cellRenderer: params => {
        const { data } = params;
        const { qustnrBgnde, qustnrEndde } = data;
        return `${qustnrBgnde && moment(qustnrBgnde).format('YYYY-MM-DD')}~
            ${qustnrEndde && moment(qustnrEndde).format('YYYY-MM-DD')}`;
      },
    },
    {
      field: 'progrsSttus',
      headerName: '상태',
      width: 100,
      cellRenderer: params => {
        const { value } = params;
        return value ? statusMap[value] : '';
      },
    },

    { field: 'frstRegisterId', headerName: '등록자', width: 100 },
    {
      field: 'frstRegistPnttm',
      headerName: '등록일',
      width: 120,
      cellRenderer: params => {
        const { value } = params;
        return value ? moment(value).format('YYYY-MM-DD') : '';
      },
    },
  ]);

  const [visible, setVisible] = useState(false);
  const [visibleRespond, setVisibleRespond] = useState(false);

  // selectedRows
  const [selectedRows, setSelectedRows] = useState([]);

  // 수정여부
  const [isEdit, setIsEdit] = useState(false);

  // 상세정보
  const [detailData, setDetailData] = useState(null);

  // 검색 Option
  const [searchOption] = useState({
    initialValues: {
      searchCondition: '0',
      searchKeyword: '',
    },
    items: [
      {
        type: 'select',
        name: 'searchCondition',
        placeholder: '선택하세요.',
        codes: [{ value: '0', text: '제목' }],
      },
      {
        name: 'searchKeyword',
        placeholder: '검색어를 입력하세요.',
        type: 'input',
        codes: [],
      },
    ],
  });

  const [respondId, setRespondId] = useState('');

  /**
   * API - 목록 조회
   */
  const {
    data,
    refetch: refetchList,
    // ...restQuery
  } = useQuery('/api/admin/question/result/selectList', search, {
    cacheTime: 0,
    enabled: !!search,
    onSuccess: res => {
      if (res) {
        setPaging(res.paginationInfo);
      }
    },
  });

  /**
   * SITE_ID(리덕스 Store)의 정보가 변경 될 시
   * 목록 리로드
   */
  useEffect(() => {
    if (!!SITE_ID && SITE_ID.length > 0) {
      setSearch(() => {
        return { ...initialSearchValues, siteId: SITE_ID };
      });
    }
  }, [SITE_ID]);

  /**
   * API - 상세정보 조회
   */
  const {
    data: detail,
    refetch: refetchDetail,
    dataUpdatedAt,
    // ...restDetailQuery
  } = useQuery(
    '/api/admin/question/result/select',
    { qestnrId: searchParams.get('qestnrId'), siteId: SITE_ID },
    {
      cacheTime: 0,
      enabled: !!searchParams.get('qestnrId'),
    },
  );

  /**
   * 페이징 처리
   * @param {*} pageIndex
   * @param {*} pageSize
   */
  const handlePagination = (pageIndex, pageSize) => {
    setSearch(preSearch => {
      return { ...preSearch, pageIndex, pageSize };
    });
  };

  /**
   * 검색 처리
   * @param {*} searchWord
   */
  const handleSearch = search => {
    setSearch(() => {
      return { ...initialSearchValues, ...search };
    });
  };

  /**
   * 행 클릭
   * @param {*} row
   * @param {*} column
   */
  const handleRowClick = params => {
    console.log('🚀 ~ handleRowClick ~ params', params);
  };

  /**
   * Cell 클릭
   * @param {*} bool
   */
  const handleCellClick = params => {
    // console.log('🚀 handleCellClick ~ params', params);
    const { data, colDef } = params;
    if (colDef?.field === 'qustnrSj' && data?.qestnrId) {
      // go Navigate
      navigate({
        pathname: '/cms/surveyAnswer',
        search: `?${createSearchParams({
          qestnrId: data.qestnrId,
        })}`,
      });

      // refetchDetail
      if (searchParams.get('qestnrId')) refetchDetail();

      // Open Drawer
      // if (!visible) handleDraw(true);
    }
  };

  /**
   * draw 핸들러
   * @param {*} bool
   */
  const handleDraw = bool => {
    setVisible(bool);
  };

  /**
   * draw 답변 핸들러
   * @param {*} bool
   */
  const handleDrawRespond = bool => {
    setVisibleRespond(bool);
  };

  /**
   * Move List page
   */
  const handleMoveList = () => {
    // Move List
    navigate('/cms/surveyAnswer');
  };

  /**
   * grid api 추가
   * @param {*} param0
   */
  const handleGridOption = ({ api }) => {
    api.sizeColumnsToFit();
    // setGridApi(api);
  };

  /**
   * grid size changed
   * @param {*} param0
   */
  const handleGridSizeChanged = ({ api }) => {
    api.sizeColumnsToFit();
  };

  /**
   * Row Selection Checked
   * @param {*} bool
   */
  const handleSelectionChanged = ({ api }) => {
    const _selectedRows = api.getSelectedRows();
    // console.log('🚀 ~ handleSelectionChanged ~ selectedRows', selectedRows);
    // Set SelectedRows
    setSelectedRows(_selectedRows);
  };

  /**
   * handleRespondId
   * @param {*} value
   */
  const handleRespondId = value => {
    setRespondId(value);
  };

  /** ***************************************************************
   *  useEffect
   *************************************************************** */
  useEffect(() => {
    if (detail?.info) {
      const { info, responds } = detail;
      const viewData = {
        info: {
          ...info,
          useAt: info.useAt === 'Y',
        },
        responds: [...responds],
      };

      // Open Drawer
      if (!visible) handleDraw(true);
      // 상세정보 세팅
      setDetailData({ ...viewData });
      // 항목 리스트
      setRespondId('');
      // 수정여부-수정
      setIsEdit(true);
    }
  }, [detail, dataUpdatedAt]);

  /**
   * props 세팅
   */
  const props = {
    paging,
    list: data?.resultList,
    columnDefs,
    gridOptions: {
      rowSelection: 'multiple', // single, multiple
      enableRangeSelection: true,
      suppressRowClickSelection: true,
      headerHeight: 40,
      // rowHeight: 40,
    },
    visible,
    visibleRespond,
    detailData,
    selectedRows,
    isEdit,
    searchOption,
    respondId,
    statusMap,
    onPaging: handlePagination,
    onRowClick: handleRowClick,
    onCellClick: handleCellClick,
    onDraw: handleDraw,
    onDrawRespond: handleDrawRespond,
    onGridReady: handleGridOption,
    onSelectionChanged: handleSelectionChanged,
    onSearch: handleSearch,
    onMoveList: handleMoveList,
    onGridSizeChanged: handleGridSizeChanged,
    onRespondId: handleRespondId,
  };

  return <SurveyAnswerView {...props} />;
}

export default SurveyAnswer;
